var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositionImplyArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.400241 6H7.60045C7.67334 5.99977 7.7448 5.97963 7.80712 5.94174C7.86944 5.90386 7.92027 5.84967 7.95413 5.785C7.988 5.72032 8.00361 5.64763 7.9993 5.57473C7.99498 5.50183 7.97091 5.43149 7.92965 5.37128L4.32955 0.161989C4.18035 -0.0539963 3.82114 -0.0539963 3.67153 0.161989L0.0714315 5.37128C0.0297603 5.43136 0.00532331 5.50174 0.000775592 5.57476C-0.00377212 5.64778 0.0117434 5.72065 0.0456364 5.78546C0.0795294 5.85027 0.130504 5.90453 0.193021 5.94235C0.255538 5.98018 0.327207 6.00011 0.400241 6Z",
    fill: "#9B9B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionImplyArrow);
export default __webpack_public_path__ + "static/media/positionImplyArrow.f3e1bf647b51d91dcd430de0aac609fc.svg";
export { ForwardRef as ReactComponent };